import { useEffect, RefObject, Component } from "react";
import ReactDOM from "react-dom";

export default function useOnKey(
  onKey: () => void,
  keyName: string | string[],
  targetRef?: RefObject<Element | Component>
) {
  useEffect(() => {
    const keyNameArr = Array.prototype.concat(keyName);
    function handleKey(event: KeyboardEvent) {
      if (keyNameArr.includes(event.key)) {
        if (targetRef && targetRef.current) {
          const domNode = ReactDOM.findDOMNode(targetRef.current);
          if (domNode && !domNode.contains(event.target as Node)) {
            // Keyboard event was not within focused targetRef, ignore
            return;
          }
        }
        // Otherwise:
        onKey();
      }
    }
    document.addEventListener("keydown", handleKey, false);

    // Return cleanup
    return () => {
      document.removeEventListener("keydown", handleKey, false);
    };
  }, [onKey, keyName, targetRef]);
}
